import axios, { AxiosError } from 'axios';
import qs from 'qs';

import { removeEmptyParams } from 'util/commonUtil';

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  paramsSerializer: param => qs.stringify(param),
  transformRequest: data => qs.stringify(data),
  withCredentials: true,
  headers: { 'Nuri-Web': 'Nuri-Web', },
  timeout: 10000

});

client.interceptors.request.use(
  config => ({ ...config, params: removeEmptyParams(config.params) }),
  error => Promise.reject(error)

);

client.interceptors.response.use(
  response => {
    if (response.data?.code === 401) {
      window.location.replace('/sign-in');
      sessionStorage.clear();
    }

    return response.data
  },
  (error: Error | AxiosError) => {
    if (!axios.isAxiosError(error)) {
      return null;
    }

    if (!error.response) {
      window.location.replace('/net-error');
      return Promise.reject(new Error('Network Error: Please check your internet connection.'));
    }

    if (error.response?.status === 401) {
      window.location.replace('/sign-in');
      sessionStorage.clear();
    }

    return Promise.reject(error);
  }

)

export default client;
